import { Auth } from 'aws-amplify';
import AWSAppSyncClient from 'aws-appsync';
import awsConfig from '../config/aws_config';

const { AppSync } = awsConfig;
AppSync.auth.credentials = () => Auth.currentCredentials();

const client = new AWSAppSyncClient(AppSync);

export default client;
